import React from "react";
import { Form, TimePicker } from "antd";

const OZTimePicker = ({
    disabled = false,
    label,
    name,
    rules,
    size = "large",
    style,
}: any) => {
    return (
        <Form.Item label={label} name={name} rules={rules}>
            <TimePicker
                disabled={disabled}
                format="HH:mm"
                minuteStep={15}
                picker="time"
                size={size}
                style={style}
            />
        </Form.Item>
    );
};

export default OZTimePicker;
